(function() {
  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-about-achievements]'));
  if (!roots.length || !window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  roots.forEach(function(root, rootIndex) {
    var numbers = Array.prototype.slice.call(root.querySelectorAll('[data-achievement-number]'));
    if (!numbers.length) return;

    function renderNumber(element, value) {
      var roundedValue = Math.round(value);
      var formatted = element.dataset.format === 'true'
        ? roundedValue.toLocaleString('en-US')
        : String(roundedValue);

      element.textContent = (element.dataset.prefix || '') + formatted + (element.dataset.suffix || '');
    }

    function showFinalValues() {
      numbers.forEach(function(element) {
        renderNumber(element, parseFloat(element.dataset.target) || 0);
      });
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      showFinalValues();
      return;
    }

    numbers.forEach(function(element) {
      renderNumber(element, 0);
    });

    ScrollTrigger.create({
      id: 'firefly-about-achievements-' + rootIndex,
      trigger: root,
      start: 'top 75%',
      once: true,
      onEnter: function() {
        numbers.forEach(function(element, index) {
          var state = { value: 0 };
          var target = parseFloat(element.dataset.target) || 0;

          gsap.to(state, {
            value: target,
            duration: 1.65,
            delay: index * 0.08,
            ease: 'power2.out',
            onUpdate: function() {
              renderNumber(element, state.value);
            },
            onComplete: function() {
              renderNumber(element, target);
            }
          });
        });
      }
    });
  });
})();
